import React from "react";
import InviteBonus from "./inviteBonus";

const inviteButton = ({
  shareUrl,
  customClassName = "inviteBonus",
  referralBoots = 0,
}) => {
  return (
    <>
      <a className={"inviteButton"} href={shareUrl}>
        {referralBoots > 0 && (
          <InviteBonus
            customClassName={customClassName}
            referralBoots={referralBoots}
          />
        )}
        {/* <img
          src="/image/inviteBonus.png"
          alt="inviteBonus"
          className={customClassName}
        /> */}
        Invite Fren
      </a>
    </>
  );
};

export default inviteButton;
